import { render, staticRenderFns } from "./the-menu.vue?vue&type=template&id=2bb05160"
import script from "./the-menu.vue?vue&type=script&lang=js"
export * from "./the-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuCategoryListPlain: require('/opt/build/repo/components/menu/category/ListPlain.vue').default,LayoutPageHeader: require('/opt/build/repo/components/layout/PageHeader.vue').default,MenuTabs: require('/opt/build/repo/components/menu/Tabs.vue').default,MenuCategoryOther: require('/opt/build/repo/components/menu/category/Other.vue').default})
